import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ROUTES_APP } from './app.routing';

import { AppComponent } from './app.component';
import { CoreModule } from './custom-modules/core.module';
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { ApiInterceptor } from "./core/interceptors/api.interceptor";
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { provideEnvironment } from "./core/providers/environment.provider";

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CoreModule,
    RouterModule.forRoot(ROUTES_APP, { useHash: true })
  ],
  providers: [
    provideEnvironment(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
